import type { TFunction } from "i18next";
import { EMPLOYMENT_OPTIONS } from "model/OrganizationalStructure";
import { WorkerEmploymentType } from "model/Salary";

export interface SharedSelectOption {
  value: string;
  label: string;
}

export const STAFF_TAX_TABLE_OPTIONS: SharedSelectOption[] = Array.from(
  { length: 36 - 29 + 1 },
  (_, index) => {
    const value = 29 + index;
    return {
      value: String(value),
      label: String(value),
    };
  },
);

/**
 * Handles to translated options.
 */
export const toTranslatedOptions = (
  options: Array<{ value: string; label: string }>,
  translate: TFunction | ((key: string) => string),
): SharedSelectOption[] => {
  return options.map((option) => ({
    value: option.value,
    label: translate(option.label),
  }));
};

const EMPLOYMENT_TYPE_TRANSLATION_KEY_BY_VALUE: Record<string, string> = {
  [WorkerEmploymentType.EMPLOYEE]: "Staff.employmentTypeEmployee",
  [WorkerEmploymentType.TEMPORARY_WORKER]:
    "Staff.employmentTypeTemporaryWorker",
  [WorkerEmploymentType.EXCLUSIVE_TEMPORARY_WORKER]:
    "Staff.employmentTypeExclusiveTemporaryWorker",
  [WorkerEmploymentType.PROJECT_EMPLOYEE]:
    "Staff.employmentTypeProjectEmployee",
  [WorkerEmploymentType.SIMFLEXITY_EMPLOYEE]:
    "Staff.employmentTypeSimflexityEmployee",
  [WorkerEmploymentType.CONSULTANT]: "Staff.employmentTypeConsultant",
  [WorkerEmploymentType.TRAINEE]: "Staff.employmentTypeTrainee",
};

const EMPLOYMENT_TYPE_DROPDOWN_ORDER: string[] = [
  WorkerEmploymentType.EMPLOYEE,
  WorkerEmploymentType.EXCLUSIVE_TEMPORARY_WORKER,
  WorkerEmploymentType.PROJECT_EMPLOYEE,
  WorkerEmploymentType.CONSULTANT,
  WorkerEmploymentType.TEMPORARY_WORKER,
  WorkerEmploymentType.SIMFLEXITY_EMPLOYEE,
  WorkerEmploymentType.TRAINEE,
];

/**
 * Handles translated employment options using Staff employment type labels.
 */
export const toEmploymentTypeOptions = (
  translate: TFunction | ((key: string) => string),
): SharedSelectOption[] => {
  const optionByValue = EMPLOYMENT_OPTIONS.reduce<
    Record<string, { value: string; label: string }>
  >((accumulator, option) => {
    accumulator[option.value] = option;
    return accumulator;
  }, {});

  return EMPLOYMENT_TYPE_DROPDOWN_ORDER.flatMap((value) => {
    const option = optionByValue[value];
    if (!option) return [];
    const translationKey =
      EMPLOYMENT_TYPE_TRANSLATION_KEY_BY_VALUE[value] ?? option.label;
    return {
      value,
      label: translate(translationKey),
    };
  });
};
